import React from 'react';
import Admin from './Admin';
import Login from './Login/Login';
import Users from './Users/Users';
import Agents from './Agents/Agents';
import Profile from './ProfileForm/Profile';
import Inventory from './Reports/Inventory';
import Sales from './Reports/Sales';
import Activity from './Reports/Activity';
import HeatMap from './Reports/HeatMap';
import Recover from './Login/Recover';

import { Switch, Route } from 'react-router-dom';

const AdminRoutes = () => (
  <Switch>
    <Route
      exact
        path="/admin"
        render={
          ({match}) => (
            <Admin match={match} />
          )
        }
    />
    <Route
      exact
        path="/admin/login"
        render={
          ({match}) => (
            <Login match={match} />
          )
        }
    />

    <Route
        path="/admin/recover-password/:token"
        render={
          ({match}) => (
            <Recover match={match} />
          )
        }
    />
    
    <Route
      exact
        path="/admin/users"
        render={
          ({match}) => (
            <Users match={match} />
          )
        }
    />

    <Route
      exact
        path="/admin/agents"
        render={
          ({match}) => (
            <Agents match={match} />
          )
        }
    />

    <Route
      exact
        path="/admin/profile"
        render={
          ({match}) => (
            <Profile match={match} />
          )
        }
    />

    <Route
      exact
        path="/admin/report/inventory"
        render={
          ({match}) => (
            <Inventory match={match} />
          )
        }
    />

    <Route
      exact
        path="/admin/report/sales"
        render={
          ({match}) => (
            <Sales match={match} />
          )
        }
    />

    <Route
      exact
        path="/admin/report/activity"
        render={
          ({match}) => (
            <Activity match={match} />
          )
        }
    />

    <Route
      exact
        path="/admin/report/heatmap"
        render={
          ({match}) => (
            <HeatMap match={match} />
          )
        }
    />

  </Switch>
);

export default AdminRoutes;
